/** Shared Kanban section title — matches ExecutiveDashboard aesthetic */

interface KanbanTitleProps {
  className?: string;
  title: string | React.ReactNode;
  titleIcon?: React.ReactNode;
  tag?: string;
  tone?: "gold" | "violet" | "cyan" | "emerald";
  headerRight?: React.ReactNode;
  titleClassName?: string;
}

const TONE_CLASSES: Record<NonNullable<KanbanTitleProps["tone"]>, string> = {
  gold: "text-[var(--fintheon-accent)] border-[var(--fintheon-accent)]/30",
  violet: "text-[#a5b4fc] border-[#6366f1]/30",
  cyan: "text-[#67e8f9] border-[#06b6d4]/30",
  emerald: "text-emerald-300 border-emerald-500/30",
};

export function KanbanTitle({
  className,
  title,
  titleIcon,
  tag,
  tone = "gold",
  headerRight,
  titleClassName,
}: KanbanTitleProps) {
  return (
    <div
      className={`flex items-center justify-between px-1 py-1 ${className ?? ""}`}
    >
      {title || tag ? (
        <div className="flex items-center gap-2">
          {titleIcon}
          {typeof title === "string" && title ? (
            <h2
              className={`text-[11px] font-semibold text-[var(--fintheon-accent)] tracking-[0.2em] uppercase ${titleClassName ?? ""}`}
            >
              {title}
            </h2>
          ) : (
            title
          )}
          {tag ? (
            <span
              className={`text-[9px] tracking-[0.22em] uppercase border rounded-full px-2 py-0.5 ${TONE_CLASSES[tone]}`}
            >
              {tag}
            </span>
          ) : null}
        </div>
      ) : (
        <span />
      )}
      {headerRight}
    </div>
  );
}
